import { coinTokens } from "../domain/coinTokens";
import type { Price } from "../domain/currency";

export async function fetchJupiterPrices() {
  const response = await fetch(
    `https://price.jup.ag/v6/price?ids=${Object.entries(coinTokens)
      .flatMap(([key, token]) => (token.fetchPrice ? [key] : []))
      .join(",")}`
  );

  if (!response.ok) {
    throw new Error(`${response.statusText} /// ${response.status}`);
  }

  const result: { data: { [key: string]: { price: number } } } =
    await response.json();

  const prices: Record<string, Price | undefined> = {};
  Object.entries(result.data).forEach(([key, entry]) => {
    prices[key] = { usd: entry?.price } as Price | undefined;
  });

  return prices;
}
